import { CallCalling, Location, Personalcard } from 'iconsax-react';
import { Link } from 'react-router-dom';
import line from '../../../../assets/images/line-verification.svg';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import {
  useHistoricCities,
  useHistoricModels,
} from '../../../../hooks/queries/useClients';
import * as styles from './styles';

export default function CollumnRight() {
  const { data: historicModel = [], isLoading: isLoadingHistoricModels } =
    useHistoricModels();

  const { data: historicCity = [], isLoading: isLoadingHistoricCities } =
    useHistoricCities();

  function renderHistoricModel() {
    const isEmpty = historicModel.length <= 0;

    if (isEmpty) {
      return <Text.Span>Sem modelos visitadas</Text.Span>;
    }

    return historicModel?.map((model) => (
      <Link to={`/model/${model.id}`} key={model.id}>
        <styles.Model>
          <img src={model.urls.profilePhoto} alt="perfil" />

          <div>
            <Text.H4 $bold>{model.fantasyName}</Text.H4>

            <Text.Span>
              <Location size={20} />
              {model.city.name} - {model.city.stateAc}
            </Text.Span>
          </div>
        </styles.Model>
      </Link>
    ));
  }

  function renderHistoricCity() {
    const isEmpty = historicCity.length <= 0;

    if (isEmpty) {
      return <Text.Span>Sem cidades visitadas</Text.Span>;
    }

    return (
      <styles.Wrap>
        {historicCity?.map((city) => (
          <Link to={`/cities/${city.id}`} key={city.id}>
            <Location size={24} />
            <Text.P>
              {city.name} - {city.stateAc}
            </Text.P>
          </Link>
        ))}
      </styles.Wrap>
    );
  }

  return (
    <styles.Container>
      <styles.GroupVerification>
        <Text.H2>Seja Verificado e Passe mais</Text.H2>
        <Text.H4>Confiança e credibilidade</Text.H4>

        <styles.Verification>
          <img src={line} alt="verification" />

          <div>
            <div>
              <CallCalling size={40} />
              <Text.P>Validar Telefone</Text.P>
            </div>

            <div>
              <Personalcard size={40} />
              <Text.P>Validar Documento</Text.P>
            </div>
          </div>

          <Link to="/clientuploads">
            <Text.P $bold>Enviar Informações</Text.P>
          </Link>
        </styles.Verification>
      </styles.GroupVerification>

      <styles.Group>
        <Text.H1>HISTÓRICO</Text.H1>

        {isLoadingHistoricModels ? (
          <Loader isLoading minimal />
        ) : (
          renderHistoricModel()
        )}

        <Link to="/followers" className="button">
          <Text.Span $bold>Ver mais</Text.Span>
        </Link>
      </styles.Group>

      <styles.Group>
        <Text.H1>
          HISTÓRICO
          <Text.P>De cidades</Text.P>
        </Text.H1>

        {isLoadingHistoricCities ? (
          <Loader isLoading minimal />
        ) : (
          renderHistoricCity()
        )}

        <Link to="/followers" className="button">
          <Text.Span $bold>Ver mais</Text.Span>
        </Link>
      </styles.Group>
    </styles.Container>
  );
}
